import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Paper, Grid, Card, CardContent } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { getMonthChart } from "../../redux/slices/caidatSlice";

export default function About() {
  const dispatch = useDispatch();
  const { currentMonth, previousMonth, today } = useSelector((s) => s.caidat);

  useEffect(() => {
    dispatch(getMonthChart());
  }, [dispatch]);
  return (
    <>
      <Box px={2} py={2}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          TỔNG QUAN
        </Typography>
        {/* Summary Cards */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4} flexGrow={1}>
            <Card
              sx={{
                bgcolor: "#1cc7b7",
                color: "#fff",
                borderRadius: 2,
                height: 120,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <CardContent>
                <Typography variant="subtitle2">DOANH THU THÁNG NÀY</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {currentMonth?.revenue?.toLocaleString() || "0"}
                </Typography>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="body2">
                    Tháng trước: <b>{previousMonth?.revenue?.toLocaleString() || "0"}</b>
                  </Typography>
                  <Box bgcolor="#fff" color="#1cc7b7" px={1.5} py={0.5} borderRadius={2} fontWeight={700} fontSize={14}>
                    {currentMonth?.revenue / previousMonth?.revenue
                      ? `${(((currentMonth?.revenue - previousMonth?.revenue) / previousMonth?.revenue) * 100).toFixed(2)}%`
                      : "0%"}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4} flexGrow={1}>
            <Card
              sx={{
                bgcolor: "#369ff4",
                color: "#fff",
                borderRadius: 2,
                height: 120,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <CardContent>
                <Typography variant="subtitle2">LƯỢT KHÁM THÁNG NÀY</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {currentMonth?.visits?.total || 0} <span style={{ fontSize: 18 }}>({currentMonth?.visits?.cancelled || 0} huỷ)</span>
                </Typography>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="body2">
                    Tháng trước:{" "}
                    <b>
                      {previousMonth?.visits?.total || 0} ({previousMonth?.visits?.cancelled || 0} huỷ)
                    </b>
                  </Typography>
                  <Box bgcolor="#fff" color="#369ff4" px={1.5} py={0.5} borderRadius={2} fontWeight={700} fontSize={14}>
                    {currentMonth?.visits?.total / previousMonth?.visits?.total
                      ? `${(((currentMonth?.visits?.total - previousMonth?.visits?.total) / previousMonth?.visits?.total) * 100).toFixed(2)}%`
                      : "0%"}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4} flexGrow={1}>
            <Card
              sx={{
                bgcolor: "#00cdff",
                color: "#fff",
                borderRadius: 2,
                height: 120,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <CardContent>
                <Typography variant="subtitle2">DOANH THU TRONG NGÀY</Typography>
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {today?.revenue?.toLocaleString() || "0"}
                </Typography>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="body2">
                    Lượt khám trong ngày: <b>{today?.visits?.total || 0}</b>
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Charts */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6} xl={6} sx={{ display: "flex", flex: 1, minWidth: 0 }}>
            <Paper
              sx={{
                p: 2,
                borderRadius: 2,
                height: 400,
                width: "100%",
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                DOANH THU THÁNG NÀY: <span style={{ color: "#f44336" }}>{currentMonth?.revenue?.toLocaleString() || "0"}</span>
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={currentMonth?.revenueData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="value" fill="#1cc7b7" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6} sx={{ display: "flex", flex: 1, minWidth: 0 }}>
            <Paper
              sx={{
                p: 2,
                borderRadius: 2,
                height: 400,
                width: "100%",
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                LƯỢT KHÁM THÁNG NÀY: <span style={{ color: "#f44336" }}>{currentMonth?.visits?.total || 0} LƯỢT</span>
              </Typography>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={currentMonth?.visitData} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="value" fill="#1cc7b7" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
